import React from 'react';
import { string } from 'prop-types';

const SuccessView = ({ btnLabelOk, labelSuccessMessage }) => {
  return (
    <div className="modal-add-to-list__success">
      <svg>
        <use xlinkHref="#tag-lines" />
      </svg>
      <p>{labelSuccessMessage}</p>
      <button className="btn btn--primary" data-generic-modal-close>
        {btnLabelOk}
      </button>
    </div>
  );
};

SuccessView.propTypes = {
  btnLabelOk: string.isRequired,
  labelSuccessMessage: string.isRequired
};

export default SuccessView;
